import axios from 'axios';

const Utils = {
  methods: {
    fetchJson(relativePath, data) {
      const path = `/.netlify/functions/${relativePath}`;
      this.$NProgress.configure({ showSpinner: false }).start();
      axios.get(path, {
        params: {
          q: data,
        },
      }).then((response) => {
        this.onSuccessJsonFetch(response);
        this.$NProgress.done();
      }).catch((error) => {
        this.onErrorJsonFetch(error);
        this.$NProgress.done();
      });
    },
  },
};

export default Utils;
